type HighAndLowUser = {
  StoreName?: string;
  Name?: string;
  UserNo?: string;
};

export const getHighAndLowUserId = (user: HighAndLowUser) => {
  return user.StoreName?.trim() || user.Name?.trim() || user.UserNo?.trim() || '셀러박스';
};
